import { render, staticRenderFns } from "./VehiculesListStock.vue?vue&type=template&id=dd5b5864&scoped=true&"
import script from "./VehiculesListStock.vue?vue&type=script&lang=js&"
export * from "./VehiculesListStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5b5864",
  null
  
)

export default component.exports